// export const url = 'http://test.api.weather.nineton.cn'
export const url = 'http://api.weather.nineton.cn'

export const api = {
  getBanner: '/ctripspot/banner',
  getNear: '/ctripspot/near',
  getNational: '/ctripspot/national',
  getDetail: '/ctripspot/detail',
  getWeather: '/ctripspot/daily',
  getRand: '/ctripspot/rand'
}
